module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('div', {
    staticClass: "checkbox-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mlb_opt_in),
      expression: "mlb_opt_in"
    }],
    staticClass: "check-style",
    attrs: {
      "type": "checkbox",
      "id": "mlb_opt_in",
      "name": "mlb_opt_in"
    },
    domProps: {
      "checked": Array.isArray(_vm.mlb_opt_in) ? _vm._i(_vm.mlb_opt_in, null) > -1 : (_vm.mlb_opt_in)
    },
    on: {
      "change": _vm.onChange,
      "__c": function($event) {
        var $$a = _vm.mlb_opt_in,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.mlb_opt_in = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.mlb_opt_in = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.mlb_opt_in = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" \n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "mlb_opt_in"
    }
  }, [_vm._v("\n            I would like to receive commercial e-mails from\n            "), _c('a', {
    staticClass: "text-success pointer",
    attrs: {
      "href": "https://www.mlb.com/cubs",
      "target": "_blank"
    }
  }, [_vm._v("cubs.com")]), _vm._v(",\n            "), _c('a', {
    staticClass: "text-success pointer",
    attrs: {
      "href": "https://www.mlb.com/",
      "target": "_blank"
    }
  }, [_vm._v("MLB.com")]), _vm._v("\n            and their partners.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73a14d5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/MlbOptIn.vue
// module id = gtDq
// module chunks = 1